export function getImageUrl(uuid?: string): string {
  if (!uuid) {
    return '';
  }
  let hash = 0;
  for (let i = 0; i < uuid.length; i++) {
    const charCode = uuid.charCodeAt(i);
    hash = (hash * 31 + charCode) | 0;
  }
  const mod = Math.abs(hash) % 85;
  const imageNumber = mod + 1;
  const paddedNumber = imageNumber.toString().padStart(2, '0');

  return `/images/users/${paddedNumber}.png`;
}
